<template>
  <v-container class="pa-0 ma-0 black" fluid>
    <Banner v-if="visible" @close="hide" />
    <v-fab-transition>
      <v-btn
        v-show="!visible"
        color="light-blue"
        dark
        fixed
        bottom
        right
        fab
        @click="show"
      >
        i
      </v-btn>
    </v-fab-transition>
    <v-row no-gutters class="ma-0 pa-0" align="start">
      <v-col
        v-for="(series, idx) in gallery"
        :key="idx"
        class="d-flex child-flex"
        cols="12"
        xl="2"
        lg="2"
        md="3"
        sm="4"
        xs="12"
      >
        <v-hover
          :value="$isMobile() && clickable(series)"
          v-slot:default="{ hover }"
          :disabled="!clickable(series)"
        >
          <router-link
            class="pa-0 ma-0"
            :to="`/artists/${series.artist.slug}`"
            v-if="clickable(series)"
          >
            <v-img
              min-width="200px"
              :src="series.photos[0].thumb"
              aspect-ratio="1"
              :class="`${getRandomColor()} ma-0`"
            >
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex flex-column align-center justify-center transition-fast-in-fast-out black darken-2 v-card--reveal white--text"
                  :style="`height: 100%; opacity:${opacity} `"
                >
                  <span class="font-weight-light">{{
                    series.artist.title
                  }}</span>
                </div>
              </v-expand-transition>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    width="2"
                    color="blue lighten-4"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </router-link>
          <v-img
            v-else
            min-width="200px"
            :src="series.photos[0].thumb"
            aspect-ratio="1"
            :class="`${getRandomColor()} ma-0`"
          >
            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex flex-column align-center justify-center transition-fast-in-fast-out black darken-2 v-card--reveal white--text"
                style="height: 100%; opacity: .9"
              >
                <span class="font-weight-light">{{ series.artist }}</span>
              </div>
            </v-expand-transition>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  width="2"
                  color="blue lighten-4"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-hover>
      </v-col>
    </v-row>
    <RouterView />
  </v-container>
</template>
<script>
import colors from "vuetify/lib/util/colors";
import Banner from "./Banner";

export default {
  name: "Series",
  components: { Banner },
  data: () => ({
    visible: false
  }),
  computed: {
    series() {
      return this.$store.state.series;
    },
    gallery() {
      return this.series;
      //return series.unshift(this.placeholder);
    },
    opacity() {
      return this.$isMobile() ? 0.6 : 0.9;
    }
  },
  methods: {
    clickable(series) {
      return !_.has(series, "clickable");
    },
    getRandomColor() {
      const keys = Object.keys(colors);
      return keys[Math.floor(Math.random() * keys.length)];
    },
    hide() {
      this.visible = false;
    },
    show() {
      this.visible = true;
    }
  }
};
</script>
<style>
a {
  color: transparent !important;
}
</style>
